var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDumoHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 191,
    viewBox: "0 0 400 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 191
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390 0H10C4.47715 0 0 4.47715 0 10V181C0 186.523 4.47715 191 10 191H390C395.523 191 400 186.523 400 181V10C400 4.47715 395.523 0 390 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 0H10C4.47715 0 0 4.47715 0 10V181C0 186.523 4.47715 191 10 191H390C395.523 191 400 186.523 400 181V10C400 4.47715 395.523 0 390 0Z",
    fill: "url(#paint0_linear_106_2)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.94,
    filter: "url(#filter0_d_106_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458 -12.5C458 14.7883 447.223 40.9724 428.015 60.3549C408.806 79.7374 382.72 90.7498 355.433 90.9958C328.146 91.2418 301.866 80.7016 282.311 61.6685C262.756 42.6355 251.509 16.6499 251.017 -10.6339C250.525 -37.9178 260.828 -64.2919 279.684 -84.0176C298.54 -103.743 324.423 -115.224 351.701 -115.962C378.979 -116.7 405.445 -106.635 425.34 -87.958C445.235 -69.2807 456.949 -43.5021 457.933 -16.2316L414.488 -14.6642C413.918 -30.4804 407.124 -45.4313 395.585 -56.2637C384.047 -67.0961 368.697 -72.9333 352.877 -72.5053C337.056 -72.0773 322.044 -65.4187 311.109 -53.9783C300.173 -42.538 294.197 -27.2416 294.482 -11.4177C294.768 4.40618 301.291 19.4771 312.632 30.5158C323.973 41.5545 339.215 47.6675 355.041 47.5248C370.867 47.3822 385.996 40.9953 397.137 29.7539C408.277 18.5126 414.527 3.32647 414.527 -12.5H458Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_2",
    x: 248,
    y: -116,
    width: 213,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.772135 0 0 0 0 0.270833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_2",
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 191,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumoHeader);
export default __webpack_public_path__ + "static/media/DumoHeader.2de0375fb0d1202b9bde43580aa46db0.svg";
export { ForwardRef as ReactComponent };